import { render, staticRenderFns } from "./GuideItemDetail.vue?vue&type=template&id=1a0aa3b7"
import script from "./GuideItemDetail.vue?vue&type=script&lang=js"
export * from "./GuideItemDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports